import { makeStyles } from "tss-react/mui";

const usePhotosDialogStyles = makeStyles()((theme) => ({
  dialogRoot: {
    "& .MuiDialog-paper": {
      margin: "10px",
      overflowX: "hidden",
      backgroundColor: theme.palette.surface.light,
    },
    "& .MuiDialog-paperFullWidth": { width: "calc(100% - 20px)" },
  },

  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "4px 16px",
  },
  icon: {
    color: theme.palette.text.primary,
  },

  /* Kamera režimo turinys */
  cameraContent: {
    padding: 0,
    backgroundColor:
      theme.palette.mode === "light" ? "#dadade" : theme.palette.surface.bg,
  },
  cameraButtonWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: "5px 0",
    position: "relative",
    backgroundColor: "#dadade",
  },

  /* Peržiūros režimo turinys */
  previewContent: {
    padding: "10px",
    backgroundColor: theme.palette.mode === "light" ? "#F4F4F8" : "#303030",
  },

  /* Mygtukas „Pridėti / Redaguoti komentarą“ */
  addCommentButton: {
    textTransform: "none",
    backgroundColor:
      theme.palette.mode === "dark"
        ? "#474747"
        : theme.palette.background.paper,
    color: theme.palette.mode === "dark" ? "white" : theme.palette.text.primary,
    width: "100%",
    justifyContent: "flex-start",
    "&:hover": {
      backgroundColor: theme.palette.mode === "dark" ? "#5a5a5a" : "#f0f0f0",
    },
  },
  /* Veiksmų mygtukai: Įkelti / Fotografuoti iš naujo / Atšaukti */
  photoActions: {
    flexDirection: "column",
    alignItems: "stretch",
    padding: 0,
    "& .MuiButton-root": {
      width: "100%",
      justifyContent: "center",
      borderBottom: "1px solid #ccc",
      borderRadius: 0,
      margin: 0,
      textTransform: "none",
    },
    "& .MuiButton-root:last-of-type": { borderBottom: "none" },
  },

  /* Dialogo antraštė (title + close button) */
  commentDialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  /* DialogContent stilius komentarų dialogui */
  commentDialogContent: {
    padding: 0,
    overflowY: "visible",
    height: "auto",
    maxHeight: "none",
  },
  /* Pilkas fonas aplink TextField */
  commentBox: {
    backgroundColor:
      theme.palette.mode === "light" ? "#dadade" : theme.palette.surface.bg,
    padding: "10px",
  },
  /* Pats TextField */
  commentTextField: {
    "& .MuiInputBase-root": {
      backgroundColor:
        theme.palette.mode === "light"
          ? theme.palette.background.paper
          : "#474747",
    },
  },
  /* Mygtukai apačioje */
  commentDialogActions: {
    display: "flex",
    justifyContent: "space-between",
    padding: 0,
    "& .MuiButton-root": { flex: 1, textTransform: "none", borderRadius: 0 },
    "& .MuiButton-root:first-of-type": { borderRight: "1px solid #ccc" },
  },

  /* Viena eilutė su failu */
  attachmentRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 0",
  },
  /* Failo blokas (checkbox + ikona + tekstas) */
  attachmentItem: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    padding: "6px 8px",
    boxSizing: "border-box",
  },
}));

export default usePhotosDialogStyles;
